const httpError = {
    state:{
        hasError:false,
        status:'',
        statusText:''
    },
    mutations : {
        ON_HTTP_ERROR(state,payload){
            state.httpError = payload
        }
    }
}
export default httpError



// WEBPACK FOOTER //
// ./src/store/modules/httpError.js